import type { FaireProductEntity } from "../../entity_types/product";

export const p_ws9bakrbf4: FaireProductEntity = {
  token: "p_ws9bakrbf4",
  type: "product",
  name: "Macaron Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/5e376d48006af3deba990a2c23db153ebe6d4d5c0f21649b02577baac94c1020.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2eb8e4e476acc50f45051f5c7d26fee56e9ed29ccdc7f8178c5ab2c989e3068c.jpeg",
    "https://cdn.faire.com/fastly/8034be0303fb6801fc436741508652126a2ce4c948ef8f2d9cd04f994ed2d4c4.jpeg",
    "https://cdn.faire.com/fastly/0d6f43a7dd62764092ea1336be0ac5d1627b59a7b3cfb0ec9379ecc439808248.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:21.340Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
